import React from 'react';

import Currency from '../../Currency/Currency';
import FormattedNumber from '../../FormattedNumber/FormattedNumber';
import { LegendFormatType } from '../Progress';
import isString from './isString';

const getLegendComponent = (value: string | number, legendFormat: LegendFormatType) => {
  let component;
  if (legendFormat === 'number') {
    component = <FormattedNumber value={value} format="0,0.0" allowZero />;
  } else if (legendFormat === 'money') {
    component = <Currency value={value} />;
  } else if (isString(legendFormat)) {
    component = <FormattedNumber value={value} format={legendFormat} allowZero />;
  } else {
    component = <Currency value={value} {...legendFormat} />;
  }

  return component;
};

export default getLegendComponent;
